import { AppSidebar } from '@/components/AppSidebar';
import { TopBar } from '@/components/TopBar';
import { useTenantSlug } from '@/hooks/useTenantSlug';
import { useEffect } from 'react';
import { Outlet, useParams } from 'react-router-dom';
import { CheckoutSheet } from '../CheckoutSheet';
import { SidebarInset, SidebarProvider } from '../ui/sidebar';
import { User } from '../user';

export function DashboardLayout() {
  const { tenantSlug: urlSlug } = useParams<{ tenantSlug: string }>();
  const { saveTenantSlug } = useTenantSlug();

  useEffect(() => {
    if (urlSlug) {
      saveTenantSlug(urlSlug);
    }
  }, [urlSlug, saveTenantSlug]);

  return (
    <SidebarProvider>
      <div className="flex h-screen w-full">
        <AppSidebar />
        <SidebarInset className="min-w-0">
          <div className="flex flex-1 flex-col h-full min-w-0 bg-[oklch(0.995_0.003_157.05)]">
            <TopBar>
              <div className="flex items-center gap-4">
                <CheckoutSheet />
                <User />
              </div>
            </TopBar>
            <main className="flex-1 overflow-y-auto overflow-x-hidden p-4 sm:p-6 dashboard-panel">
              <Outlet />
            </main>
          </div>
        </SidebarInset>
      </div>
    </SidebarProvider>
  );
}
